import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { SpacesLimitAddonModalComponent } from "./SpacesLimitAddonModalComponent";
import { SpacesLimitAddonModalUIKitComponent } from "./SpacesLimitAddonModalUIKitComponent";

const SpacesLimitAddonModalUIKit = ModalManager.create(() => (
  <SpacesLimitAddonModalUIKitComponent />
));

const SpacesLimitAddonModalCompass = ModalManager.create(() => {
  const modal = useModal();
  return (
    <SpacesLimitAddonModalComponent
      open={modal.visible}
      onOpenChange={open => {
        if (!open) void modal.hide();
      }}
    />
  );
});

export const useSpacesLimitAddonModal = () => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  const compassModal = useModal(SpacesLimitAddonModalCompass);
  const uikitModal = useModal(SpacesLimitAddonModalUIKit);
  return isCircleV4 ? compassModal : uikitModal;
};
